import React, { createContext, useContext, useEffect, useState } from 'react'
import { IProps } from './index'
import globalBRPSpacingCSS from 'marketing-site/src/styles/themes/default-global-spacing.scss'

export const SpacingContext = createContext(false)

export const SpacingProvider = ({ children, useSpacing = false }: IProps) => {
  const [spacing, setSpacing] = useState<boolean>(useSpacing)

  useEffect(() => {
    if (useSpacing) {
      setSpacing(useSpacing)
      return
    }
  }, [useSpacing, setSpacing])

  return (
    <SpacingContext.Provider value={spacing}>
      {spacing && <style jsx>{globalBRPSpacingCSS}</style>}
      {children}
    </SpacingContext.Provider>
  )
}

export const useSpacing = () => useContext(SpacingContext)
